// extracted by mini-css-extract-plugin
module.exports = {"scrollee":"Scrollee_scrollee__3Yu_e","scrolleeShifted":"Scrollee_scrolleeShifted__3CSmo"};